// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_TreatmentCard_Content_TreatmentPlans_Steps_Content_PaymentPlans($treatment_id: uuid!) {
  vaxiom_tx_plans(
    where: { deleted: { _eq: false }, tx: { _id: { _eq: $treatment_id } } }
    order_by: { name: asc_nulls_last }
  ) {
    id
    _id
    name
    fee
    length_in_weeks
    insurance_code_id
    tx_plan_template {
      id
      tx_plan_group_id
    }
  }
}

`